import { CvFilterModel, LogicalOperator, QueryOperator, ValuesType } from '../filter-model';
import { CvFilterDto } from '../../../../services/api-client/models/cv-filter-dto';

export enum CV_FILTERING_FIELDS {
  GREYBEE_ROLE = 'greybeeRole',
  NAME = 'name',
  FREE_TEXT = 'freeText',
  LAST_NAME = 'lastname',
  CERTIFICATIONS = 'certifications',
  INDUSTRY_EXERCISE = 'industryExpertise'
}

export class FilterViewModel {
  operator?: QueryOperator;
  logicalOperator?: LogicalOperator;
  filterType?: ValuesType;
  cvFilterModel: CvFilterModel;
  values: string[];
  field: string;

  constructor(
    field: string,
    operator: QueryOperator  = QueryOperator.EQUALS,
    values: string[] | string,
    logicalOperator: LogicalOperator,
    filterType: ValuesType = ValuesType.TEXT,
  ) {
    this.operator = operator;
    this.values = typeof values === 'string' ? this.values = [values] : this.values = values;
    this.logicalOperator = logicalOperator;
    this.filterType = filterType;
    this.field = field;

    this.cvFilterModel = new CvFilterModel(
      this.field,
      this.operator,
      this.values,
      this.logicalOperator,
      this.filterType
    );
  }
}

export const allovedGreybeeRoles: string[] = ['Junior project Manager', 'Middle project Manager', 'Seniour project Manager'];

export const allovedIndustryExerciseNames: string[] = ['Value1', 'Value2', 'Value3'];

export function convertCvFilterModelToDto(filterModel: CvFilterModel): CvFilterDto {
  const dto: CvFilterDto = {};

  dto.field = filterModel.field;

  if (filterModel.logicalOperator === LogicalOperator.AND) {
    dto.logicalOperator = 'AND';
  } else if (filterModel.logicalOperator === LogicalOperator.OR) {
    dto.logicalOperator = 'OR';
  }

  if (filterModel.operator === QueryOperator.EQUALS) {
    dto.operator = 'EQUALS';
  } else if (filterModel.operator === QueryOperator.LIKE) {
    dto.operator = 'LIKE';
  }

  if (filterModel.filterType === ValuesType.TEXT) {
    dto.valueType = 'TEXT';
  } else if (filterModel.filterType === ValuesType.DROPDOWN) {
    dto.valueType = 'DROPDOWN';
  }

  dto.values = filterModel.values;

  return dto;
}
